import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as GC from "../../../../common/common";
import * as CallBackFunctions from "../functions/callBackFunctions";

export default function standart() {}

export const fillDetail = () => {
  $("#budget-naam").html(window.$catalog_budget_selectedRow.naam);
  $("#budget-naam-tooltip").html(window.$catalog_budget_selectedRow.naam);
  $("#budget-code").html(window.$catalog_budget_selectedRow.code);
  $("#budget-omschrijving").html(
    window.$catalog_budget_selectedRow.omschrijving
  );
  if (window.$catalog_budget_selectedRow.isActive)
    $("#budget-active").attr("checked", "checked");
  else $("#budget-active").removeAttr("checked");

  //editSide
  $("#e-budget-naam").val(window.$catalog_budget_selectedRow.naam);
  $("#e-budget-code").val(window.$catalog_budget_selectedRow.code);
  $("#e-budget-omschrijving").val(
    window.$catalog_budget_selectedRow.omschrijving
  );

  if (window.$catalog_budget_selectedRow.isActive)
    $("#e-budget-active").attr("checked", "checked");
  else $("#e-budget-active").removeAttr("checked");
  $("#budget-identification").val(
    window.$catalog_budget_selectedRow.identification
  );
};

export const treeClickControl = (clickId) => {
  if (clickId === process.env.REACT_APP_CATALOG_BUDGET) {
    window.$catalog_budget_last_tree_click.budget = true;
    window.$catalog_budget_last_tree_click.grootboek = false;
  } else {
    window.$catalog_budget_last_tree_click.budget = false;
    window.$catalog_budget_last_tree_click.grootboek = true;
  }
};


export const rowsHandleDelete = () => {
  // 1. bu kayıtın relationlarını getir.
  // 2. tüm relationlarını sil.
  // 3. sonra kayıtı sil.
  $("#cover-spin").show(0);
  var BreakException = {};
  window.$catalog_budget_selectedIds.forEach(async (element) => {
    try {

      const relations = await omnimap.GetRelationAction(
          element,
          1,
          30,
          window.$catalog_management_units_token
      );

      /**
       * * 1. silinmek istenen kayıtın beheerobject ilişkisi varsa sinemez olması gerekmektedir
       */

      if (relations.data !== undefined) {
        await relations.data.forEach(async (relation) =>
          omnimap.DeleteRelationAction(relation.identification, window.$catalog_management_units_token)
              .catch((error) => console.log(error))
        );
      }

      GC.sleep(2000).then(async () => {
        await omnimap
            .Delete(element, window.$catalog_management_units_token)
            .catch((error) => {
              console.log(error);
            });

        CallBackFunctions.RowsDeletedCallBack(
            window.$catalog_management_units_token
        );
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    }
  });
};